import { SearchModel } from "@/types/SearchModel";
import { Dispatch, SetStateAction } from "react";

export default function SearchBar({
  search,
  setSearch,
  filterList,
}: {
  search: SearchModel;
  setSearch: Dispatch<SetStateAction<SearchModel>>;
  filterList: () => void;
}) {
  const searchThroughList = (e: any) => {
    if (e.target.name == "ville")
      setSearch({ ...search, ville: e.target.value });
    else setSearch({ ...search, codePostal: e.target.value });
  };

  return (
    <div className="my-10 flex content-between justify-center max-sm:flex-col max-sm:space-y-2">
      <div className="relative mx-3 rounded-md border border-gray-400 px-3 py-2 shadow-sm focus-within:border-[#009EE2] focus-within:ring-1 focus-within:ring-[#009EE2]">
        <label
          htmlFor="ville"
          className="absolute -top-2 left-2 -mt-px inline-block bg-white px-1 text-xs font-medium text-gray-900"
        >
          Ville
        </label>
        <input
          type="text"
          name="ville"
          id="ville"
          className="block border-0 p-0 text-gray-900 placeholder-gray-400 focus:ring-0 sm:text-sm"
          placeholder="Mons, Bruxelles"
          onChange={searchThroughList}
        />
      </div>
      <div className="relative mx-3 rounded-md border border-gray-400 px-3 py-2 shadow-sm focus-within:border-[#009EE2] focus-within:ring-1 focus-within:ring-[#009EE2]">
        <label
          htmlFor="codePostal"
          className="absolute -top-2 left-2 -mt-px inline-block bg-white px-1 text-xs font-medium text-gray-900"
        >
          Code Postal
        </label>
        <input
          type="text"
          name="codePostal"
          id="codePostal"
          className="block border-0 p-0 text-gray-900 placeholder-gray-400 focus:ring-0 sm:text-sm"
          placeholder="7000"
          onChange={searchThroughList}
        />
      </div>
      <button
        onClick={filterList}
        className="z-10 inline-flex items-center rounded border border-transparent bg-[#0079AD] px-5 py-2 text-base font-medium text-white shadow-sm hover:bg-[#005E87] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 max-sm:justify-center sm:-ml-4 sm:rounded-r-lg"
      >
        Rechercher
      </button>
    </div>
  );
}
